
// // function fixFilterSpacing() {
// //     document.querySelectorAll('.gf-option-box li button').forEach(button => {
// //         button.style.display = 'flex';
// //         button.style.justifyContent = 'flex-start';
// //         button.style.alignItems = 'center';
// //         button.style.gap = '2px';

// //         const label = button.querySelector('.gf-label');
// //         const count = button.querySelector('.gf-count');

// //         if (label) {
// //             label.style.flex = '0 1 auto';
// //             label.style.marginRight = '-1px';
// //             label.style.width = 'auto';
// //             label.style.maxWidth = '165px';
// //         }

// //         if (count) {
// //             count.style.marginLeft = '0';
// //             count.style.flex = '0 0 auto';
// //         }
// //     });
// // }
// // fixFilterSpacing();
// // new MutationObserver(fixFilterSpacing).observe(document.body, {
// //     childList: true,
// //     subtree: true
// // });





    (function () {
  const LIMIT = 5;
  function hideItems(block) {
    const items = block.querySelectorAll(".gf-option-box > li");

    items.forEach(function (item, index) {
      item.style.display = index < LIMIT ? "" : "none";
    });
  }
  function showItems(block) {
    block.querySelectorAll(".gf-option-box > li").forEach(function (item) {
      item.style.display = "";
    });
  }
  function updateState(block) {
    const btn = block.querySelector(".gf-btn-show-more");
    if (!btn) return;
    const text = btn.textContent.trim().toLowerCase();
    if (text.includes("less")) {
      showItems(block);
    } else {
      hideItems(block);
    }
  }
  function initCollectionFilter() {
    document
      .querySelectorAll('.gf-option-block[data-filter-type="Collection"]')
      .forEach(function (block) {
        const btn = block.querySelector(".gf-btn-show-more");
        if (!btn) return;
        updateState(block);
        if (!btn.dataset.bound) {
          btn.dataset.bound = "true";
          btn.addEventListener("click", function () {
            setTimeout(function () {
              updateState(block);
            }, 200);
          });
        }
      });
  }
  initCollectionFilter();
  const observer = new MutationObserver(function () {
    setTimeout(function () {
      initCollectionFilter();
    }, 200);
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();


// (function () {
//   const LIMIT = 5;
//   const GLOBO_THRESHOLD = 10;
//   function init() {
//     document.querySelectorAll('.gf-option-block[data-filter-type="Collection"]').forEach(function (block) {
//       if (block.dataset.customInit === "true") return;
//       const list = block.querySelector(".gf-option-box");
//       if (!list) return;
//       const items = list.querySelectorAll(":scope > li");
//       const total = items.length;
//       if (total <= LIMIT) return;
//       if (total >= GLOBO_THRESHOLD) return;
//       block.dataset.customInit = "true";
//       items.forEach(function (item, index) {
//         if (index >= LIMIT) {
//           item.style.display = "none";
//         }
//       });
//       const btn = document.createElement("button");
//       btn.type = "button";
//       btn.className = "custom-view-more";
//       btn.textContent = "Show more";
//       btn.style.cssText =
//         "font:inherit;cursor:pointer;";
//       list.parentNode.appendChild(btn);

//       let expanded = false;

//       btn.addEventListener("click", function () {
//         expanded = !expanded;

//         items.forEach(function (item, index) {
//           if (index >= LIMIT) {
//             item.style.display = expanded ? "" : "none";
//           }
//         });

//         btn.textContent = expanded ? "Show more" : "Show less";
//       });
//     });
//   }
//   init();
//   const observer = new MutationObserver(function () {
//     init();
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();




// (function () {
//   function addMargin() {
//     const selectors = [
//       '.gf-option-block[data-filter-id="598597"]',
//       '.gf-option-block[data-filter-id="598607"]'
//     ];
//     selectors.forEach(selector => {
//       const block = document.querySelector(selector);
//       if (block) {
//         block.style.setProperty("margin-top", "20px", "important");
//       }
//     });
//   }
//   addMargin();
//   const observer = new MutationObserver(() => {
//     addMargin();
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();

(function () {
  function initShowMore() {
    const filterBlock = document.querySelector(
      '.gf-option-block[data-filter-id="598607"]'
    );
    if (!filterBlock) return;
    const optionBox = filterBlock.querySelector(".gf-option-box");
    if (!optionBox) return;
    if (optionBox.dataset.showMoreInit === "true") return;
    optionBox.dataset.showMoreInit = "true";
    const items = optionBox.querySelectorAll(":scope > li");
    const totalItems = items.length;
    console.log("filter length:", totalItems);
    if (totalItems > 10) return;
    const LIMIT = 5;

    if (totalItems <= LIMIT) {
  return;
}

    function hideItems() {
      items.forEach((item, index) => {
        item.style.display = index < LIMIT ? "block" : "none";
      });
      showMoreBtn.style.display = "inline-block";
      showLessBtn.style.display = "none";
    }
    function showItems() {
      items.forEach(item => {
        item.style.display = "block";
      });
      showMoreBtn.style.display = "none";
      showLessBtn.style.display = "inline-block";
    }
    filterBlock.querySelector(".custom-show-more")?.remove();
    filterBlock.querySelector(".custom-show-less")?.remove();
    const showMoreBtn = document.createElement("button");
    showMoreBtn.className = "custom-show-more";
    showMoreBtn.textContent = "Show More";
    showMoreBtn.style.cssText =
    "margin-top:10px;background:none;border:none;cursor:pointer;font-size:14px !important;";
    const showLessBtn = document.createElement("button");
    showLessBtn.className = "custom-show-less";
    showLessBtn.textContent = "Show Less";
    showLessBtn.style.cssText =
    "margin-top:10px;background:none;border:none;cursor:pointer;display:none;font-size:14px !important;";
    showLessBtn.style.display = "none";
    optionBox.after(showLessBtn);
    optionBox.after(showMoreBtn);
    showMoreBtn.addEventListener("click", showItems);
    showLessBtn.addEventListener("click", hideItems);
    hideItems();
  }
  setTimeout(initShowMore, 1000);
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        clearTimeout(window.showMoreTimer);
        window.showMoreTimer = setTimeout(initShowMore, 300);
        break;
      }
    }
  });
  observer.observe(document.querySelector("#gf-grid") || document.body, {
    childList: true,
    subtree: true
  });

})();


jQuery(document).ready(function(){
  setTimeout(function(){
    if(jQuery("body").hasClass("template-collection")){
      console.log("Jquery working here");
      $('.template-collection ul.globo-dropdown-custom__options li[data-sort="stock-descending"]').click();
    }
  }, 1200)
})

